import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import {logout, setAccessToken} from '../../store/actions/utilsActions/utilsActions'
import {brandList, brandListReset} from "../../store/actions/brandActions/brandListActions";

function Dashboard() {
    const dispatch = useDispatch();
    const brandReducer = useSelector(state => state.brandListReducers);

    const accessToken = useSelector((state) => state.utilReducers.accessToken);
    const [statusFilter, setStatusFilter] = useState('PENDING');

    useEffect(() => {
        dispatch(brandList({statusFilter:statusFilter}));
    }, []);

    useEffect(() => {
        if (brandReducer?.status === 200) {
            console.log("brand data", brandReducer.data);
            dispatch(brandListReset());
        } else if(brandReducer.authStatus === 401){
            dispatch(logout());
        } else if (brandReducer?.status) {
            dispatch(brandListReset());
        }
    }, [brandReducer]);

    return (
        <div className="">

            <div className="text-4xl ml-2 mb-4 leading-[40px] ">
            Dashboard Page!!

            </div>
        </div>

    )
}

export default Dashboard
